// extracted by css-extract-rspack-plugin
export default {"labelCell":"RP5wOEdNIFvgHaIE","rolloutValue":"baAAmC4qMv0EkuTk","rowValue":"DsGzkLmyk_Y6BE5m","detailsLink":"FURYT5NwoTsH3ACH","tableIndent":"Jl5ppaA_o8JkZk2r"};